<template>
    <div id="CLineBreak">
        <div v-if="title || $slots.default" class="overflow-hidden text-center">
            <span
                class="relative inline-block before:absolute before:right-full before:top-2/4 before:mx-4 before:w-[591px] before:border before:content-[''] after:absolute after:left-full after:top-2/4 after:mx-4 after:w-[591px] after:border after:content-['']"
                :class="
                    darkColor
                        ? 'after:border-gray-840 after:dark:border-default before:border-gray-840 before:dark:border-default'
                        : 'after:border-gray-400 after:dark:border-default before:border-gray-400 before:dark:border-default'
                "
            >
                <slot v-if="$slots.default" />
                <template v-else>
                    {{ title }}
                </template>
            </span>
        </div>
        <template v-else>
            <hr :class="darkColor ? 'border-gray-840 dark:border-default' : 'border-gray-400 dark:border-default'" />
        </template>
    </div>
</template>

<script setup lang="ts">
interface Props {
    title?: string | number
    darkColor?: boolean
    noMargin?: boolean
}

defineProps<Props>()
</script>
